/** Minimal stroke icons for the admin dashboard (monochrome, currentColor). */
const base = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
};

export const MenuIcon = () => (
  <svg {...base} width="20" height="20"><path d="M4 6h16M4 12h16M4 18h16" /></svg>
);
export const StarIcon = () => (
  <svg viewBox="0 0 32 32" width="19" height="19" fill="currentColor" aria-hidden="true">
    <path d="M16 3.2l3.5 7.1 7.8 1.13-5.65 5.5 1.34 7.77L16 21.3l-6.99 3.4 1.34-7.77-5.65-5.5 7.8-1.13z" />
  </svg>
);
export const SearchIcon = () => (
  <svg {...base} width="18" height="18"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.2-4.2" /></svg>
);
export const PanelIcon = () => (
  <svg {...base} width="18" height="18"><rect x="3" y="4" width="18" height="16" rx="2" /><path d="M9 4v16" /></svg>
);
export const ChevronIcon = () => (
  <svg {...base} width="16" height="16"><path d="M6 9l6 6 6-6" /></svg>
);
export const OverviewIcon = () => (
  <svg {...base} width="18" height="18"><path d="M4 13h7V4H4zM13 20h7v-9h-7zM13 4h7v4h-7zM4 20h7v-4H4z" /></svg>
);
export const LinkIcon = () => (
  <svg {...base} width="18" height="18"><path d="M10 13a5 5 0 007 0l2-2a5 5 0 00-7-7l-1 1M14 11a5 5 0 00-7 0l-2 2a5 5 0 007 7l1-1" /></svg>
);
export const RevenueIcon = () => (
  <svg {...base} width="18" height="18"><path d="M12 2v20M17 6.5C17 4.6 14.8 3.5 12 3.5S7 4.6 7 6.5 9.2 9.5 12 10s5 1.5 5 3.5-2.2 3.5-5 3.5-5-1.1-5-3" /></svg>
);
export const ChartIcon = () => (
  <svg {...base} width="18" height="18"><path d="M4 20V4M4 20h16M8 16v-4M12 16V8M16 16v-7" /></svg>
);
export const PlayIcon = () => (
  <svg {...base} width="18" height="18"><rect x="3" y="5" width="18" height="14" rx="3" /><path d="M10 9l5 3-5 3z" fill="currentColor" stroke="none" /></svg>
);
export const CalendarIcon = () => (
  <svg {...base} width="18" height="18"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 9h18M8 3v4M16 3v4" /></svg>
);
export const GridIcon = () => (
  <svg {...base} width="18" height="18"><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></svg>
);
export const SparkIcon = () => (
  <svg {...base} width="18" height="18"><path d="M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5L18 18M18 6l-2.5 2.5M8.5 15.5L6 18" /></svg>
);
export const OutIcon = () => (
  <svg {...base} width="14" height="14"><path d="M7 17L17 7M9 7h8v8" /></svg>
);
export const SignOutIcon = () => (
  <svg {...base} width="16" height="16"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" /></svg>
);
